import 'angular-local-storage';
import 'angular-mocks';

import createStub from '../olr-common/createStub';
import OauthService from './OauthService';

let namespace = angular.module('olr-mainfe-oauth2', [
  "LocalStorageModule"
]);

namespace.service('OauthService', OauthService);

export default namespace.name;




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-oauth2/index.js
 **/